import { Button, FlashMessage, Modal, SingleFileDropZone, ConfirmDialog } from "../../common";
import React, { useState, useEffect } from "react";
import DeleteIcon from "../icons/delete-icon.svg";
import { ReactComponent as ArticleIconPink } from "../icons/article-pink.svg";
import UploadResume from "../icons/upload-resume-icon.svg";
import ResumeUploadedIcon from "../icons/resume-uploaded-icon.svg";
import EditIcon from "../icons/edit-icon.svg";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import { useForm } from "react-hook-form";
import {
  uploadCandidateResumeRequest,
  uploadCandidateResumeReset,
  deleteCandidateResumeRequest,
  // parseCandidateResumeRequest,
  parseCandidateResumeReset,
  resetDeleteCandidateResume
} from "../../../reducers/candidate/candidate.reducer";
import { useDispatch, useSelector } from "react-redux";
import { ReducerFlag } from "../../../types/reducer.types";
import { rootReducersState } from "../../../reducers";
import ResumeModal from "../../../pages/CandidateProfile/Profile/ResumeModal";
import { validateFileSize } from "../../helpers/formValidation";
import { updateCandidateResumeFile, setCandidateResumes, fetchSessionDataRequest } from "../../../reducers/auth/session.reducer";
import { formatDate, openUrlInNewTab } from "../../../utils/helper";
import httpRequest from "../../../utils/httpRequest";
import useSessionUser from "../../../hooks/useSessionUser";
import candidateServices from "../../../services/candidate.services";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import _ from "lodash";
import { useParams } from "react-router-dom";
import {
  MoreVert as MoreVertIcon
} from "@material-ui/icons";
import { IconButton, Menu, MenuItem } from "@material-ui/core";

interface ResumeSectionProps {
  resumeData: ResumeInterface[] | null;
  userProfileData: any;
  isPublicPage?: boolean;
  openRequest?: boolean;
  onOpenHandled?: () => void;
}

export interface ResumeInterface {
  id: number;
  resume_file: string;
  original_file: string;
  mime_type: string;
  created_at: string;
  is_primary: number;
  is_profile_upload: number;
  resume_visibility?: number; // 0 = private, 1 = public
}

function ResumeSection({
  resumeData,
  userProfileData,
  isPublicPage,
  openRequest,
  onOpenHandled,
}: ResumeSectionProps) {
  const dispatch = useDispatch();
  const { currentSlug } = useSessionUser();
  const params = useParams<{ slug?: string }>();
  const {
    resumeDataFlag,
    deleteResumeLoading,
    deleteResumeFlag,
    deleteResumeId,
    uploadResumeLoading,
    resumeData: parsedResumeData,
    resumeFile,
    uploadedResumeMeta,
    parseResumeFlag,
    message,
    uploadResumeFlag,
  } = useSelector(({ candidate }: rootReducersState) => candidate.candidates);


  const [resumeModal, setResumeModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [isPublic, setIsPublic] = useState(false);
  const [isParsing, setIsParsing] = useState(false);
  const [parsedModal, setParsedModal] = useState(false);
  const [deleteResumeModal, setDeleteResumeModal] = useState(false);
  const [resumeViewModal, setResumeViewModal] = useState(false);
  const [resumePreviewPath, setResumePreviewPath] = useState<string>("");
  const [resumeParsedData, setResumeParsedData] = useState<any>({});
  const [localResumeData, setLocalResumeData] = useState<ResumeInterface[]>(
    Array.isArray(resumeData) ? resumeData : []
  );
  const [resumeToDeleteId, setResumeToDeleteId] = useState<number | null>(null);
  const [resumeToDeleteKey, setResumeToDeleteKey] = useState<string | null>(null);
  const [editResumeModalResume, setEditResumeModalResume] = useState<ResumeInterface | null>(null);
  const [editResumeMenuAnchor, setEditResumeMenuAnchor] = useState<null | HTMLElement>(null);
  const [publicResumeMenuAnchor, setPublicResumeMenuAnchor] =
    useState<null | HTMLElement>(null);
  const [publicMenuResume, setPublicMenuResume] =
    useState<ResumeInterface | null>(null);
  const [loadingPublicResumePreview, setLoadingPublicResumePreview] =
    useState(false);
  const [showReplaceZone, setShowReplaceZone] = useState(false);
  const [replaceFile, setReplaceFile] = useState<File | null>(null);
  const replacingResumeIdRef = React.useRef<number | null>(null);
  const replacingVisibilityRef = React.useRef<number>(0);
  const uploadVisibilityRef = React.useRef<number>(0);
  const replaceFileInputRef = React.useRef<HTMLInputElement>(null);
  const [editResumeIsPublic, setEditResumeIsPublic] = useState(false);
  const [editResumeIsPrimary, setEditResumeIsPrimary] = useState(false);
  const [editResumeSubmitLoading, setEditResumeSubmitLoading] = useState(false);

  const { handleSubmit } = useForm({
    defaultValues: {},
  });

  const validateFileType = (file: File): boolean => {
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    return allowedTypes.includes(file.type);
  };

  const syncSessionResumes = (resumes: ResumeInterface[]) => {
    dispatch(setCandidateResumes(resumes));
    const primary =
      resumes.find((r) => Number(r.is_primary) === 1) || resumes[0];
    dispatch(
      updateCandidateResumeFile(
        primary?.resume_file ? String(primary.resume_file) : ""
      )
    );
  };

  // Sync local resume data with props when session/profile refreshes
  useEffect(() => {
    if (!Array.isArray(resumeData)) {
      setLocalResumeData([]);
      return;
    }
    // Keep optimistic local uploads when session resumes haven't synced yet
    if (resumeData.length === 0) {
      return;
    }
    setLocalResumeData(resumeData);

    // eslint-disable-next-line
  }, [resumeData]);


  useEffect(() => {
    if (resumeDataFlag) {
      setParsedModal(true);
    }
  }, [resumeDataFlag]);

  // Handle delete resume response
  useEffect(() => {
    if (deleteResumeFlag === ReducerFlag.SUCCESS) {
      let nextResumes: ResumeInterface[] = [];
      setLocalResumeData((prev) => {
        nextResumes = prev.filter((r) => {
          if (deleteResumeId != null && deleteResumeId > 0) {
            return Number(r.id) !== Number(deleteResumeId);
          }
          if (resumeToDeleteKey) {
            return (
              r.resume_file !== resumeToDeleteKey &&
              r.original_file !== resumeToDeleteKey
            );
          }
          return true;
        });
        return nextResumes;
      });
      syncSessionResumes(nextResumes);
      setResumeToDeleteId(null);
      setResumeToDeleteKey(null);
      setDeleteResumeModal(false);
      dispatch(resetDeleteCandidateResume());
      dispatch(fetchSessionDataRequest());
    } else if (deleteResumeFlag === ReducerFlag.FAILED) {
      FlashMessage("Unable to delete resume", "error");
      dispatch(resetDeleteCandidateResume());
      setResumeToDeleteId(null);
      setResumeToDeleteKey(null);
    }
    // eslint-disable-next-line
  }, [deleteResumeFlag, deleteResumeId, resumeToDeleteKey, dispatch]);

  // Handle parse resume response
  useEffect(() => {
    if (parseResumeFlag === ReducerFlag.SUCCESS) {
      dispatch(parseCandidateResumeReset());
    }
    if (parseResumeFlag === ReducerFlag.FAILED) {
      FlashMessage(message, "error");
      dispatch(parseCandidateResumeReset());
    }
    // eslint-disable-next-line
  }, [parseResumeFlag, message, dispatch]);

  // Handle upload response using flag
  useEffect(() => {
    if (uploadResumeFlag === ReducerFlag.SUCCESS) {
      setResumeModal(false);
      setUploadedFiles([]);
      setIsPublic(false);
      setIsParsing(false);
      setResumeParsedData(parsedResumeData);
      if (isParsing) {
        setParsedModal(true);
      }
      const replaceId = replacingResumeIdRef.current;
      const visibility = replaceId != null ? replacingVisibilityRef.current : uploadVisibilityRef.current;
      const uploadMeta = uploadedResumeMeta ?? {};
      let nextResumes: ResumeInterface[] = [];
      setLocalResumeData((prev) => {
        const next = Array.isArray(prev) ? [...prev] : [];
        const newEntry: ResumeInterface = {
          id: Number(uploadMeta.id) || 0,
          resume_file: String(uploadMeta.resume_file || resumeFile),
          original_file: String(uploadMeta.original_file || resumeFile),
          mime_type: String(uploadMeta.mime_type || ""),
          created_at: String(uploadMeta.created_at || new Date().toISOString()),
          is_primary: Number(uploadMeta.is_primary) || (next.length === 0 ? 1 : 0),
          is_profile_upload: 1,
          resume_visibility:
            Number(uploadMeta.resume_visibility ?? visibility) || visibility,
        };
        if (replaceId != null && replaceId > 0) {
          const idx = next.findIndex((r) => r.id === replaceId);
          if (idx >= 0) {
            next[idx] = { ...next[idx], resume_file: resumeFile, original_file: resumeFile, resume_visibility: visibility };
          } else {
            next.push(newEntry);
          }
          nextResumes = next;
          return next;
        }
        next.push(newEntry);
        nextResumes = next;
        return next;
      });
      syncSessionResumes(nextResumes);
      replacingResumeIdRef.current = null;
      if (replaceId != null) {
        setShowReplaceZone(false);
        setReplaceFile(null);
        setEditResumeModalResume(null);
        setEditResumeMenuAnchor(null);
      }
      dispatch(uploadCandidateResumeReset());
      dispatch(fetchSessionDataRequest());
    } else if (uploadResumeFlag === ReducerFlag.FAILED) {
      replacingResumeIdRef.current = null;
      console.error("Upload failed");
      dispatch(uploadCandidateResumeReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadResumeFlag]);



  const onSubmit = async (data: any) => {
    // Validate that a file is uploaded
    if (uploadedFiles.length === 0) {
      alert('Please select a file to upload');
      return;
    }
    if (!validateFileType(uploadedFiles[0])) {
      FlashMessage("Please upload only PDF, DOC, or DOCX files", "error");
      return;
    }

    const fileSize = validateFileSize(uploadedFiles[0].size, 2);
    if (!_.isEmpty(fileSize)) {
      FlashMessage(fileSize, "error");
      return;
    }
    // Create FormData for file upload
    const formData = new FormData();

    // Add the resume file
    formData.append('resume', uploadedFiles[0]);

    // Determine action based on parsing preference
    const isParsedRequired = isParsing ? 'true' : 'false';

    // Visibility: 0 = private, 1 = public (API expects number)
    const resumeVisibility = isPublic ? 1 : 0;
    uploadVisibilityRef.current = resumeVisibility;

    formData.append('isParsedRequired', isParsedRequired);
    formData.append('resume_visibility', String(resumeVisibility));

    dispatch(uploadCandidateResumeRequest({ payload: formData }));
  };

  const onFileUpload = (file: File) => {
    setUploadedFiles((prev) => [...prev, file]);
  };

  const onDeleteFile = (index: number) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleModalClose = () => {
    setResumeModal(false);
    // Reset form state when closing modal
    setUploadedFiles([]);
    setIsPublic(false);
    setIsParsing(false);
  };

  // const handleResumeUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   if (!validateFileType(file)) {
  //     FlashMessage("Please upload only PDF, DOC, or DOCX files", "error");
  //     e.target.value = '';
  //     return;
  //   }

  //   const fileSize = validateFileSize(file.size, 2);
  //   if (!_.isEmpty(fileSize)) {
  //     FlashMessage(fileSize, "error");
  //     return;
  //   }

  //   const payload = new FormData();
  //   payload.append("resume", file);
  //   payload.append("isParsedRequired", String(isParsing));
  //   payload.append("visibility", isPublic ? "public" : "private");
  //   dispatch(uploadCandidateResumeRequest({ payload }));
  // };

  // const handleFileUploadResume = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   if (!validateFileType(file)) {
  //     FlashMessage("Please upload only PDF, DOC, or DOCX files", "error");
  //     e.target.value = '';
  //     return;
  //   }

  //   const fileSize = validateFileSize(file.size, 10);
  //   if (!_.isEmpty(fileSize)) {
  //     FlashMessage(fileSize, "error");
  //     return;
  //   }

  //   const payload = new FormData();
  //   payload.append("resume", file);
  //   dispatch(parseCandidateResumeRequest({ payload }));
  // };

  const handleRemoveFile = () => {
    const id =
      resumeToDeleteId != null && resumeToDeleteId > 0
        ? resumeToDeleteId
        : undefined;
    if (id == null) {
      FlashMessage("Unable to delete resume. Please refresh and try again.", "error");
      setDeleteResumeModal(false);
      return;
    }
    dispatch(deleteCandidateResumeRequest({ id }));
    setDeleteResumeModal(false);
  };

  const openEditResumeModal = (resume: ResumeInterface) => {
    if (isPublicPage) return;
    setEditResumeModalResume(resume);
    setShowReplaceZone(false);
    setReplaceFile(null);
    // resume_visibility: 0 = private, 1 = public (API returns 1 or 0). Coerce so string "1" works.
    setEditResumeIsPublic(Number(resume.resume_visibility) === 1);
    setEditResumeIsPrimary(Number(resume.is_primary) === 1);
  };

  const openUploadResumeModal = () => {
    if (isPublicPage) return;
    setResumeModal(true);
    setIsPublic(false);
    setIsParsing(false);
  };

  useEffect(() => {
    if (!openRequest || isPublicPage) return;
    openUploadResumeModal();
    onOpenHandled?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openRequest, isPublicPage]);

  const closeEditResumeModal = () => {
    setEditResumeModalResume(null);
    setEditResumeMenuAnchor(null);
    setShowReplaceZone(false);
    setReplaceFile(null);
  };

  const openDeleteModal = (resume: ResumeInterface) => {
    setResumeToDeleteId(resume.id > 0 ? resume.id : null);
    setResumeToDeleteKey(resume.resume_file || resume.original_file || null);
    setDeleteResumeModal(true);
    setEditResumeMenuAnchor(null);
    closeEditResumeModal();
  };

  const handleSetPrimary = async (resume: ResumeInterface) => {
    setEditResumeMenuAnchor(null);
    setLocalResumeData((prev) =>
      prev.map((r) => ({
        ...r,
        is_primary: r.id === resume.id ? 1 : 0,
      }))
    );
    setEditResumeModalResume((prev) => (prev && prev.id === resume.id ? { ...prev, is_primary: 1 } : prev));
    setEditResumeIsPrimary(resume.id === editResumeModalResume?.id);
    try {
      await candidateServices.updateCandidateResume(resume.id, { is_primary: 1 });
      FlashMessage("Primary resume updated", "success");
    } catch {
      FlashMessage("Unable to set primary", "error");
    }
  };

  const handleUnsetPrimary = async (resume: ResumeInterface) => {
    setEditResumeMenuAnchor(null);
    const others = localResumeData.filter((r) => r.id !== resume.id);
    const nextPrimary = others[0];
    setLocalResumeData((prev) =>
      prev.map((r) => ({
        ...r,
        is_primary: r.id === nextPrimary?.id ? 1 : r.id === resume.id ? 0 : r.is_primary,
      }))
    );
    setEditResumeModalResume((prev) => (prev && prev.id === resume.id ? { ...prev, is_primary: 0 } : prev));
    setEditResumeIsPrimary(false);
    try {
      await candidateServices.updateCandidateResume(resume.id, { is_primary: 0 });
      if (nextPrimary) {
        await candidateServices.updateCandidateResume(nextPrimary.id, { is_primary: 1 });
      }
      FlashMessage("Primary resume updated", "success");
    } catch {
      FlashMessage("Unable to update primary", "error");
    }
  };

  const handleEditResumeView = (resume: ResumeInterface) => {
    setEditResumeMenuAnchor(null);
    handleShowResume(resume);
  };

  const handleEditResumeDownload = (resume: ResumeInterface) => {
    setEditResumeMenuAnchor(null);
    setPublicResumeMenuAnchor(null);
    setPublicMenuResume(null);
    if (resume.resume_file) {
      openUrlInNewTab(resume.resume_file);
    } else {
      FlashMessage("No file available", "error");
    }
  };

  const handleReplaceResumeClick = () => {
    setEditResumeMenuAnchor(null);
    setShowReplaceZone(true);
  };

  const onReplaceFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!validateFileType(file)) {
      FlashMessage("Please upload only PDF, DOC, or DOCX files", "error");
      e.target.value = "";
      return;
    }
    const fileSize = validateFileSize(file.size, 2);
    if (!_.isEmpty(fileSize)) {
      FlashMessage(fileSize, "error");
      e.target.value = "";
      return;
    }
    setReplaceFile(file);
    e.target.value = "";
  };

  const onReplaceFileRemove = () => {
    setReplaceFile(null);
    replaceFileInputRef.current?.value && (replaceFileInputRef.current.value = "");
  };

  const handleEditResumeSubmit = async () => {
    if (!editResumeModalResume) return;
    if (replaceFile) {
      // Replace file: use PATCH to update existing resume with new file (not POST upload)
      if (!validateFileType(replaceFile)) {
        FlashMessage("Please upload only PDF, DOC, or DOCX files", "error");
        return;
      }
      const fileSize = validateFileSize(replaceFile.size, 2);
      if (!_.isEmpty(fileSize)) {
        FlashMessage(fileSize, "error");
        return;
      }
      const formData = new FormData();
      formData.append("resume", replaceFile);
      formData.append("resume_visibility", String(editResumeIsPublic ? 1 : 0));
      formData.append("is_primary", String(editResumeIsPrimary ? 1 : 0));
      formData.append("isParsedRequired", "false");
      setEditResumeSubmitLoading(true);
      try {
        const res = await candidateServices.updateCandidateResume(editResumeModalResume.id, formData);
        if (res.flag) {
          const resData = "data" in res ? res.data : undefined;
          const updatedFile = (resData as { original_file?: string } | undefined)?.original_file ?? replaceFile.name;
          setLocalResumeData((prev) =>
            prev.map((r) => {
              if (r.id !== editResumeModalResume.id) {
                return editResumeIsPrimary ? { ...r, is_primary: 0 } : r;
              }
              return {
                ...r,
                resume_file: updatedFile,
                original_file: updatedFile,
                resume_visibility: editResumeIsPublic ? 1 : 0,
                is_primary: editResumeIsPrimary ? 1 : 0,
              };
            })
          );
          FlashMessage(res.message || "Resume updated successfully", "success");
          closeEditResumeModal();
          setShowReplaceZone(false);
          setReplaceFile(null);
        } else {
          FlashMessage(res.message || "Unable to update resume", "error");
        }
      } catch {
        FlashMessage("Unable to update resume", "error");
      } finally {
        setEditResumeSubmitLoading(false);
      }
      return;
    }
    setEditResumeSubmitLoading(true);
    try {
      const res = await candidateServices.updateCandidateResume(editResumeModalResume.id, {
        resume_visibility: editResumeIsPublic ? 1 : 0,
        is_primary: editResumeIsPrimary ? 1 : 0,
      });
      if (res.flag) {
        setLocalResumeData((prev) =>
          prev.map((r) => {
            if (r.id !== editResumeModalResume.id) {
              return editResumeIsPrimary ? { ...r, is_primary: 0 } : r;
            }
            return {
              ...r,
              resume_visibility: editResumeIsPublic ? 1 : 0,
              is_primary: editResumeIsPrimary ? 1 : 0,
            };
          })
        );
        FlashMessage(res.message || "Resume updated successfully", "success");
        closeEditResumeModal();
      } else {
        FlashMessage(res.message || "Unable to update resume", "error");
      }
    } catch {
      FlashMessage("Unable to update resume", "error");
    } finally {
      setEditResumeSubmitLoading(false);
    }
  };

  const handleShowResume = async (resume: ResumeInterface) => {
    setPublicResumeMenuAnchor(null);
    setPublicMenuResume(null);
    try {
      if (isPublicPage) {
        const slug = params.slug || "";
        if (!slug) {
          FlashMessage("Resume not found", "error");
          return;
        }
        setLoadingPublicResumePreview(true);
        const base = `candidates/profile/public/resume/${slug}/preview`;
        const previewUrl =
          resume.id != null && resume.id > 0
            ? `${base}?resume_id=${resume.id}`
            : base;
        const { data } = await httpRequest().post(previewUrl);
        const path = data.path;
        if (path) {
          setResumePreviewPath(path);
          setResumeViewModal(true);
        } else {
          FlashMessage("Resume not found", "error");
        }
      } else {
        if (resume.id == null || resume.id <= 0) {
          FlashMessage("Resume not found", "error");
          return;
        }
        const { data } = await httpRequest().post(
          `candidates/profile/resume/${currentSlug}/preview?resume_id=${resume.id}`
        );
        const path = data.path;
        if (path) {
          setResumePreviewPath(path);
          setResumeViewModal(true);
        } else {
          FlashMessage("Resume not found", "error");
        }
      }
    } catch (error) {
      FlashMessage("Resume not found", "error");
    } finally {
      if (isPublicPage) {
        setLoadingPublicResumePreview(false);
      }
    }
  };



  return (
    <div className="accordion" id="profile-resume">
      <div className="accordion-head">
        <b>Resume</b>
        {
          !isPublicPage && localResumeData.length <= 2 ? (
            <span onClick={openUploadResumeModal}>+Add</span>
          ) : ""
        }
      </div>
      {Array.isArray(localResumeData) && localResumeData.length > 0 && (
      <div className="accordion-body">
        {
          localResumeData.map((resume) => (
            <div
              className={`resume-content ${!isPublicPage ? "resume-row-clickable" : ""}`}
              key={
                resume.id > 0
                  ? resume.id
                  : resume.resume_file || resume.original_file
              }
              onClick={() => !isPublicPage && openEditResumeModal(resume)}
              role={isPublicPage ? undefined : "button"}
              tabIndex={isPublicPage ? undefined : 0}
              onKeyDown={(e) =>
                e.key === "Enter" && !isPublicPage && openEditResumeModal(resume)
              }
            >
              <div className="resume-icon">
                <ArticleIconPink />
              </div>
              <div className="resume-info resume-original-file">
                <span>{resume?.original_file || "Resume"}</span>
                <span className="resume-original-file-uploaded-on">
                  {resume?.created_at
                    ? `Uploaded on ${formatDate(resume.created_at)}`
                    : ""}
                </span>
              </div>
              {isPublicPage ? (
                <div className="resume-actions-right">
                  <IconButton
                    className="resume-three-dots"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPublicResumeMenuAnchor(e.currentTarget);
                      setPublicMenuResume(resume);
                    }}
                    aria-label="Resume options"
                  >
                    <MoreVertIcon />
                  </IconButton>
                </div>
              ) : (
                <div
                  className="edit-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    openEditResumeModal(resume);
                  }}
                >
                  <img src={EditIcon} alt="edit" />
                </div>
              )}
            </div>
          ))
        
        }
        {isPublicPage && (
          <Menu
            id="public-resume-menu"
            anchorEl={publicResumeMenuAnchor}
            keepMounted
            open={Boolean(publicResumeMenuAnchor)}
            onClose={() => {
              setPublicResumeMenuAnchor(null);
              setPublicMenuResume(null);
            }}
            classes={{ paper: "border-radius-md" }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              disabled={loadingPublicResumePreview}
              onClick={() => publicMenuResume && handleShowResume(publicMenuResume)}
            >
              View
            </MenuItem>
            <MenuItem
              onClick={() =>
                publicMenuResume && handleEditResumeDownload(publicMenuResume)
              }
            >
              Download
            </MenuItem>
          </Menu>
        )}
      </div>
      )}

      <Modal
          visible={resumeModal}
          onClose={handleModalClose}
          className={`candidate-profile-modal resume-modal`}
          title="Upload Resume"
        >
          <form
            className="modal-body-wrapper"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="upload-resume-wrapper">
              <SingleFileDropZone
                allowFileTypes={["pdf"]}
                allowFileSize={1048576}
                disabled={uploadedFiles.length > 0}
                content={
                  <div className="upload-resume-content">
                    <div className="icon">
                      <img src={UploadResume} alt="icon" />
                    </div>
                    <p>Drag & drop your resume here or click to upload</p>
                  </div>
                }
                onSuccess={onFileUpload}
              />
            </div>
            <div className="form-group">
              <label className="form-label">
                Who should be able to view your resume
              </label>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div className="switch-wrapper">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!isPublic}
                          onChange={() => setIsPublic(!isPublic)}
                          color="primary"
                        />
                      }
                      label={"Private"}
                    />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="switch-wrapper">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isParsing}
                          onChange={() => setIsParsing(!isParsing)}
                          color="primary"
                        />
                      }
                      label={"Parsing"}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            {uploadedFiles.length > 0 && (
              <div className="uploaded-resume-wrapper">
                {uploadedFiles.map((file, index) => (
                  <div key={index} className="uploaded-resume">
                    <div className="icon">
                      <img src={ResumeUploadedIcon} alt="icon" />
                    </div>
                    <div className="resume-content">
                      <div>
                        <b>{file.name}</b>
                        <span>
                          Uploaded on {formatDate(new Date().toISOString())}
                        </span>
                      </div>
                      <div
                        className="delete-icon"
                        onClick={() => onDeleteFile(index)}
                      >
                        <img src={DeleteIcon} alt="icon" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="btn-wrapper">
              <Button
                variant="outlined"
                className="outlined"
                onClick={handleModalClose}
                color="none"
              >
                Cancel
              </Button>
              <Button
                className="save-btn"
                type="submit"
                loading={uploadResumeLoading}
                disabled={uploadedFiles.length === 0}
              >
                Submit
              </Button>
            </div>
          </form>
        </Modal>

        <ConfirmDialog
          visible={deleteResumeModal}
          bodyText="Are you sure want to Delete this resume?"
          confirmText="Delete"
          loading={deleteResumeLoading}
          onConfirm={handleRemoveFile}
          onCancel={() => {
            setDeleteResumeModal(false);
            setResumeToDeleteId(null);
            setResumeToDeleteKey(null);
          }}
        />

        <Modal
          visible={!!editResumeModalResume}
          onClose={closeEditResumeModal}
          className="candidate-profile-modal resume-modal resume-edit-modal"
          title="Edit Resume"
        >
          <div className="modal-body-wrapper">
            {editResumeModalResume && (
              <>
                <p className="main-subtitle">You can upload a maximum of 3 resumes. Select one primary resume to apply for jobs.</p>
                <div className="uploaded-resume-wrapper resume-edit-card">
                  <div className="uploaded-resume">
                    <div className="icon">
                      <img src={ResumeUploadedIcon} alt="resume" />
                    </div>
                    <div className="resume-content">
                      <div>
                        <b>{editResumeModalResume?.original_file || "Resume"}</b>
                        <span>
                          Uploaded on {editResumeModalResume?.created_at ? formatDate(editResumeModalResume?.created_at) : "—"}
                        </span>
                      </div>
                      <div className="edit-resume-card-actions">
                        <IconButton
                          size="small"
                          className="edit-resume-three-dots"
                          onClick={(e) => setEditResumeMenuAnchor(e.currentTarget)}
                          aria-label="Resume options"
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          anchorEl={editResumeMenuAnchor}
                          open={Boolean(editResumeMenuAnchor)}
                          onClose={() => setEditResumeMenuAnchor(null)}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                          {Number(editResumeModalResume.is_primary) === 1 ? (
                            <MenuItem onClick={() => handleUnsetPrimary(editResumeModalResume)}>
                              Unset as Primary
                            </MenuItem>
                          ) : (
                            <MenuItem onClick={() => handleSetPrimary(editResumeModalResume)}>
                              Set as Primary
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => handleEditResumeView(editResumeModalResume)}>
                            View
                          </MenuItem>
                          <MenuItem onClick={handleReplaceResumeClick}>
                            Replace resume
                          </MenuItem>
                          <MenuItem onClick={() => handleEditResumeDownload(editResumeModalResume)}>
                            Download
                          </MenuItem>
                          <MenuItem
                            onClick={() => openDeleteModal(editResumeModalResume)}
                            className="text-danger"
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    Who should be able to view your resume
                  </label>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <div className="switch-wrapper">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!editResumeIsPublic}
                              onChange={() => setEditResumeIsPublic(!editResumeIsPublic)}
                              color="primary"
                            />
                          }
                          label={"Private"}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div className="switch-wrapper">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={!!editResumeIsPrimary}
                              onChange={() => {
                                const next = !editResumeIsPrimary;
                                setEditResumeIsPrimary(next);
                                setEditResumeModalResume((prev) =>
                                  prev ? { ...prev, is_primary: next ? 1 : 0 } : prev
                                );
                              }}
                              color="primary"
                            />
                          }
                          label={"Set as Primary"}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                {showReplaceZone && (
                  <div className="replace-resume-zone">
                    <input
                      ref={replaceFileInputRef}
                      type="file"
                      accept=".pdf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      onChange={onReplaceFileSelect}
                      className="replace-file-input-hidden"
                    />
                    <div className="replace-resume-file-row">
                      <Button
                        variant="outlined"
                        className="outlined"
                        onClick={() => replaceFileInputRef.current?.click()}
                        color="none"
                      >
                        Choose file
                      </Button>
                      {replaceFile && (
                        <div className="replace-file-preview">
                          <span className="replace-file-name">{replaceFile.name}</span>
                          <button
                            type="button"
                            className="replace-file-remove"
                            onClick={onReplaceFileRemove}
                            aria-label="Remove file"
                          >
                            <img src={DeleteIcon} alt="remove" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="btn-wrapper">
                  <Button
                    variant="outlined"
                    className="outlined"
                    onClick={closeEditResumeModal}
                    color="none"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="save-btn"
                    onClick={handleEditResumeSubmit}
                    loading={uploadResumeLoading || editResumeSubmitLoading}
                    disabled={uploadResumeLoading || editResumeSubmitLoading}
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
          </div>
        </Modal>

        <Modal
          visible={resumeViewModal}
          onClose={() => {
            setResumeViewModal(false);
          }}
          title="View Resume"
          size="x-large"
          className="resume-upload-modal"
        >
          <div className="flex-column align-items-center mb-20">
            <DocViewer
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                  retainURLParams: true,
                },
              }}
              style={{ width: "100%", height: "auto" }}
              documents={[
                {
                  uri: resumePreviewPath,
                },
              ]}
              pluginRenderers={DocViewerRenderers}
            />
          </div>
        </Modal>

      <ResumeModal
        parsedModal={parsedModal}
        setParsedModal={setParsedModal}
        resumeData={resumeParsedData}
        userProfile={userProfileData}
        closeResumeModal={() => setParsedModal(false)}
      />
    </div>
  );
}

export default ResumeSection;
